/**
 * @generated SignedSource<<bab5bbc9eb43c910d6594dd4b0405db0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TransportationCode = "CADDIE" | "CADDIE_CART" | "CART" | "FULL_CART" | "MOTOR_PULL_CART" | "PRIVATE_CART" | "PULL_CART" | "SINGLE_CART" | "WALK";
import { FragmentRefs } from "relay-runtime";
export type ConfigureRoundTransportationTypeControl_Booking$data = {
  readonly rounds: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly startSlot: {
    readonly transportationTypes: ReadonlyArray<{
      readonly code: TransportationCode | null | undefined;
      readonly customCode: string | null | undefined;
      readonly eighteenHolePrice: number | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly nineHolePrice: number | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ConfigureRoundTransportationTypeControl_Booking";
};
export type ConfigureRoundTransportationTypeControl_Booking$key = {
  readonly " $data"?: ConfigureRoundTransportationTypeControl_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigureRoundTransportationTypeControl_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConfigureRoundTransportationTypeControl_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "memberVisible",
              "value": true
            }
          ],
          "concreteType": "TransportationType",
          "kind": "LinkedField",
          "name": "transportationTypes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "customCode",
              "storageKey": null
            },
            {
              "alias": "eighteenHolePrice",
              "args": [
                {
                  "kind": "Literal",
                  "name": "holeCount",
                  "value": "EIGHTEEN"
                }
              ],
              "kind": "ScalarField",
              "name": "totalPrice",
              "storageKey": "totalPrice(holeCount:\"EIGHTEEN\")"
            },
            {
              "alias": "nineHolePrice",
              "args": [
                {
                  "kind": "Literal",
                  "name": "holeCount",
                  "value": "NINE"
                }
              ],
              "kind": "ScalarField",
              "name": "totalPrice",
              "storageKey": "totalPrice(holeCount:\"NINE\")"
            }
          ],
          "storageKey": "transportationTypes(memberVisible:true)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "40e1057dc5186a06d7344ce385aa213d";

export default node;
